var StateModel = /** @class */ (function () {
    function StateModel() {
    }
    return StateModel;
}());
export { StateModel };
